import React from 'react';
export const VIEWBOX_CENTER_X = 50;
export const VIEWBOX_CENTER_Y = 50;
const getPathDescription = (pathRadius, center = { x: VIEWBOX_CENTER_X, y: VIEWBOX_CENTER_Y }) => `
      M ${center.x},${center.y}
      m 0,-${pathRadius}
      a ${pathRadius},${pathRadius} 0 1 1 0,${2 * pathRadius}
      a ${pathRadius},${pathRadius} 0 1 1 0,-${2 * pathRadius}
    `;
const getDashStyle = ({ dashRatio, pathRadius }) => {
    const circumference = Math.PI * 2 * pathRadius;
    const gapLength = (1 - dashRatio) * circumference;
    return {
        strokeDasharray: `${circumference}px ${circumference}px`,
        strokeDashoffset: `${gapLength}px`,
    };
};
const Path = ({ dashRatio, pathRadius, style, classes, center }) => (React.createElement("path", { strokeLinecap: "round", style: Object.assign(Object.assign(Object.assign({}, style), getDashStyle({ pathRadius, dashRatio })), { fillOpacity: 0 }), d: getPathDescription(pathRadius, center), className: classes }));
export default Path;
